import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import * as Notify from "@repoflow/form-schema/notify";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import { CancellableContent } from "@repoflow/components/content-cancel";
import * as QueriesQL from "queries/organization";

export const Sidebar = () => null;

export const Indice = () => (
  <>
    <BreadcrumbItem>Edit</BreadcrumbItem>
  </>
);

export const Content = ({ history, match: { params } }) => {
  const {
    parent: { base },
  } = useSectionContext();

  return (
    <Mutation
      target={{ $ref: "/Public/Organization/Update" }}
      mutation={QueriesQL.edit}
      update={QueriesQL.update(params)}
      onMutate={({ handler, state: { values } }) => {
        handler({ variables: { ...params, input: values } });
      }}
      onCompleted={() => {
        history.replace(base);
      }}
      onError={(error) => {
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({ target, state, schema, mutate }) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    onSubmit: () => {
      mutate();
    },
    onChange: (values) => {
      setValues(values);
    },
    config: {
      "/Public/Organization/Update": {
        fields: ["description"],
      },
    },
    values,
  };

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit">Edit</Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
